const API_BASE_HUBS_CMS_V1 = '/api/hubs-cms/v1'
const API_BASE_HUBS_CMS_V2 = '/api/hubs-cms/v2'
const API_BASE_HUBS_CMS_V3 = '/api/hubs-cms/v3'
const API_BASE_HUBS_CMS_V4 = '/api/hubs-cms/v4'
const API_BASE_OAUTH_V3 = '/api/v3/oauth'
const API_BASE_COMMUNITY_SERVICE_V1 = '/api/community-service/v1'
const API_BASE_AVATAR = '/api/meetingareaselector/v1/newgenavatar'
const API_BASE_RETICULUM = '/api/v5'
const API_BASE_MARKET_GRAPHQL = '/graphql'

export const API_ENDPOINT_AVATARS = `${API_BASE_HUBS_CMS_V1}/avatars`
export const API_GET_ROOMS_V1 = `${API_BASE_HUBS_CMS_V1}/rooms`
export const API_GET_ROOMS_EXPLORE = `${API_BASE_HUBS_CMS_V1}/rooms/explore`
export const API_GET_ROOM_SETTINGS = `${API_BASE_HUBS_CMS_V1}/room-settings`
export const API_MY_ROOMS_V1 = `${API_BASE_HUBS_CMS_V1}/my-rooms`
export const API_GET_SCENES = `${API_BASE_HUBS_CMS_V1}/scenes`
export const API_ADD_ROOM_UPLOAD_ASSET = `${API_BASE_HUBS_CMS_V1}/upload-asset`
export const API_GET_THEMES = `${API_BASE_HUBS_CMS_V1}/themes`
export const API_GET_EDITOR_CHOICES = `${API_BASE_HUBS_CMS_V2}/editor-choices`
export const API_GET_MY_GIVEAWAY_LIST = `${API_BASE_HUBS_CMS_V1}/giveaways`
export const API_GET_EVENTS = `${API_BASE_HUBS_CMS_V1}/events`
export const API_GET_ACTIVITY_SHOWCASE = `${API_BASE_HUBS_CMS_V1}/activity-showcase`
export const API_GET_RECOMMEND_CREATORS = `${API_BASE_HUBS_CMS_V1}/recommend-creators`
export const API_GET_ROOM_TAGS = `${API_BASE_HUBS_CMS_V1}/room-tags`
export const API_GET_ROOM_TAGS_V2 = `${API_BASE_HUBS_CMS_V2}/room-tags`
export const API_GET_ROOM_PREFERRED_DEVICES = `${API_BASE_HUBS_CMS_V1}/room-preferred-devices`
export const API_GET_SEARCH_ACCOUNTS = `${API_BASE_HUBS_CMS_V1}/search-accounts`
export const API_POST_ACCOUNTS_SEARCH_V2 = `${API_BASE_HUBS_CMS_V2}/accounts/search`
export const API_POST_ROOMS_SEARCH = `${API_BASE_HUBS_CMS_V2}/rooms/search`
export const API_GET_ROOM_SEARCH_FACETS = `${API_BASE_HUBS_CMS_V2}/rooms/search/facets`
export const API_GET_RECOMMEND_WORLDS = `${API_BASE_HUBS_CMS_V2}/recommend-worlds`
export const API_GET_CREATOR_TUTORIAL = `${API_BASE_HUBS_CMS_V1}/creator-tutorial`
export const API_GET_HUBS = `${API_BASE_HUBS_CMS_V1}/hubs`
export const API_POST_RECOMMEND_WORLDS = `${API_BASE_HUBS_CMS_V1}/recommendation/worlds`
export const API_RECENT_SEARCH_V1 = `${API_BASE_HUBS_CMS_V1}/me/recent-search`
export const API_GET_VIDEO_STATE = `${API_BASE_HUBS_CMS_V1}/bv/upload/status`

export const API_ROOMS_V2 = `${API_BASE_HUBS_CMS_V2}/rooms`
export const API_GET_ROOMS_AUTOCOMPLETE = `${API_BASE_HUBS_CMS_V2}/rooms/autocomplete`
export const API_GET_LIKED_ROOMS_V3 = `${API_BASE_HUBS_CMS_V3}/me/liked-rooms`
export const API_GET_ME_SAVED_WORLDS = `${API_BASE_HUBS_CMS_V1}/me/saved-worlds`
export const API_MY_ROOMS_V2 = `${API_BASE_HUBS_CMS_V2}/my-rooms`
export const API_GET_MY_ROOMS_V3 = `${API_BASE_HUBS_CMS_V3}/my-rooms`
export const API_GET_VOUCHER_ROOMS_V2 = `${API_BASE_HUBS_CMS_V2}/vouchers`

export const API_ACCOUNTS_V3 = `${API_BASE_HUBS_CMS_V3}/accounts`
export const API_PATCH_ME_V3 = `${API_BASE_HUBS_CMS_V3}/me`
export const API_ROOMS_V3 = `${API_BASE_HUBS_CMS_V3}/rooms`

export const API_ACCOUNTS_V4 = `${API_BASE_HUBS_CMS_V4}/accounts`
export const API_GET_ME_V4 = `${API_BASE_HUBS_CMS_V4}/me`

export const API_GET_ROOM_META_DATA = `${API_BASE_HUBS_CMS_V1}/hubs`

export const API_ENPOINT_LOGIN = `${API_BASE_OAUTH_V3}/login`
export const API_ENPOINT_LOGOUT = `${API_BASE_OAUTH_V3}/logout`
export const API_GET_LOGIN_STATUS = `${API_BASE_OAUTH_V3}/login-status`
export const API_GET_VERIFY_TOKEN = '/api/auth/verify-token'

export const API_CHECK_USER_COMMUNITY_PERMISSION = `${API_BASE_COMMUNITY_SERVICE_V1}/isused`
export const API_COMMUNITY_USER = `${API_BASE_COMMUNITY_SERVICE_V1}/user`
export const API_COMMUNITY_SEARCHABLE = `${API_BASE_COMMUNITY_SERVICE_V1}/searchable`

export const API_GET_FOLLOWING_ROOMS = `${API_BASE_HUBS_CMS_V4}/me/following-rooms`

export const API_GET_STANDALONE_CONTENT = `${API_BASE_HUBS_CMS_V1}/standalone/contents`

export const API_ENDPOINT_COMMENTS_V2 = `${API_BASE_HUBS_CMS_V2}/comments`
export const API_ENDPOINT_COMMENTS_COUNT = `${API_BASE_HUBS_CMS_V1}/comments/count`

export const API_GET_MARKET_PLAN_LIST = `${API_BASE_MARKET_GRAPHQL}`

export const API_ENDPOINT_USER_TASKS = `${API_BASE_HUBS_CMS_V1}/user-tasks`

export const API_ME_PARTNER = `${API_BASE_HUBS_CMS_V1}/me/partner`

export const API_GET_ROOM_POSTMESSAGE_ORIGINS = (roomId: string) =>
  `${API_BASE_HUBS_CMS_V3}/rooms/${roomId}/postmessage-origins`

export const API_ME_WATCH_HISTORY_ROOMS = `${API_BASE_HUBS_CMS_V1}/me/watch-history/rooms`
export const API_ME_RECENT_WATCHED_ROOMS = `${API_BASE_HUBS_CMS_V1}/me/watch-history/recent-rooms`
